import React from "react";
import { cn } from "@/lib/utils";

const variantClass = {
    primary: "btn-primary",
    copper: "btn-copper",
    secondary: "btn-secondary",
    danger: "btn-danger",
};

const sizeClass = {
    sm: "text-xs px-3 py-1.5",
    md: "text-sm",
    lg: "text-base px-6 py-3",
};

export const NxButton = ({
    children,
    variant = "primary",
    size = "md",
    loading = false,
    disabled = false,
    className = "",
    type = "button",
    testId,
    icon,
    ...rest
}) => {
    return (
        <button
            type={type}
            disabled={disabled || loading}
            data-testid={testId}
            className={cn(
                "inline-flex items-center justify-center gap-2 select-none relative",
                variantClass[variant] || variantClass.primary,
                sizeClass[size],
                loading && "pointer-events-none",
                className,
            )}
            {...rest}
        >
            {loading ? (
                <span className="copper-skeleton absolute inset-1 rounded-md" aria-hidden />
            ) : null}
            <span className={cn("inline-flex items-center gap-2", loading && "opacity-0")}>
                {icon}
                {children}
            </span>
        </button>
    );
};
